import { useSelectorToQueryParam } from '../shared/useSelectorToQueryParam'

export function useOnlyHotel() {
  const {
    optionSelected,
    pushQueryParam,
  } = useSelectorToQueryParam({
    label: 'only-hotel',
    defaultValue: ''
  })

  const onlyHotel = computed(() => {
    if (!optionSelected.value) {
      return false
    }

    return optionSelected.value.value === 'true'
  })

  function onOnlyHotelClick() {
    pushQueryParam((!onlyHotel.value) + '')
  }

  return {
    onlyHotel,
    onOnlyHotelClick,
  }
}
